module.exports = __webpack_public_path__ + "img/k3.94667826.svg";